export const isCommented = (text, commentMarker = "#") => {
    return text.some((line) => line.startsWith(commentMarker));
};
export const uncommentText = (text, commentMarker = "#") => {
    return text
        .map((line) => {
        if (line.startsWith(commentMarker)) {
            return line.substring(commentMarker.length ? commentMarker.length : 1);
        }
        else {
            return line;
        }
    })
        .join("\n");
};
export const commentText = (text, commentMarker = "#") => {
    return text
        .map((line) => {
        return commentMarker + line;
    })
        .join("\n");
};
const dateExpression = /^\d\s\d{4}\/\d{2}\/\d{2}\-\d{2}\:\d{2}\:\d{2}\.\d{6}$/;
const intervalExpression = /^\d\s\d{4}\/\d{2}\/\d{2}\-\d{2}\:\d{2}\:\d{2}\.\d{6}\s+\d\s\d{4}\/\d{2}\/\d{2}\-\d{2}\:\d{2}\:\d{2}\.\d{6}$/;
export const formatVariables = (variable) => {
    if (variable.match(intervalExpression)) {
        variable = `createinterval(${variable
            .replace(/\s\s/g, " ")
            .replace(/\s/g, ",")})`;
    }
    else if (variable.match(dateExpression)) {
        variable = `createdate(${variable.replace(/\s/g, ",")})`;
    }
    return variable;
};
export const getProgramAndPanel = (match) => {
    const text = match[0].substring(match[0].indexOf(" ") + 1);
    const program = text.split(" ")[0].toLowerCase();
    const panel = text
        .substring(text.indexOf(" ") + 1)
        .replace(/"/g, "")
        .trim();
    return { program, panel };
};
//# sourceMappingURL=utils.js.map